import { render, staticRenderFns } from "./AppliedOverPaymentsSummary.vue?vue&type=template&id=20f56054&scoped=true&"
import script from "./AppliedOverPaymentsSummary.vue?vue&type=script&lang=js&"
export * from "./AppliedOverPaymentsSummary.vue?vue&type=script&lang=js&"
import style0 from "./AppliedOverPaymentsSummary.vue?vue&type=style&index=0&id=20f56054&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f56054",
  null
  
)

export default component.exports